import React, { createContext, useReducer, useContext } from "react";

const NotificationContext = createContext();

function notificationReducer(state, action) {
  switch (action.type) {
    case "add": {
      return {
        notifications: [...action.notifications],
      };
    }
    case "remove": {
      const updatedState = [...state.notifications];
      updatedState.splice(action.index, 1);
      return {
        notifications: updatedState,
      };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function NotificationProvider({ children }) {
  const [state, dispatch] = useReducer(notificationReducer, { count: 0 });
  const value = { state, dispatch };
  return (
    <NotificationContext.Provider value={value}>
      {children}
    </NotificationContext.Provider>
  );
}

function useNotification() {
  const context = useContext(NotificationContext);
  if (context === undefined) {
    throw new Error(
      "useNotification must be used within a NotificationProvider"
    );
  }
  return context;
}

export { NotificationProvider, useNotification };
